import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { fmtDay } from '../../lib/format';

export interface DayRow { day: string; uk: number; us: number }

const UK = '#5856D6';
const US = '#0EA5A0';

/** Stacked bars per London day: UK and US. */
export const DailySplit: React.FC<{ data: DayRow[]; height?: number; unit?: string }> = ({ data, height = 200, unit }) => {
  const step = Math.max(1, Math.ceil(data.length / 10));
  return (
    <div>
      <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: -22 }} barCategoryGap="22%">
          <CartesianGrid vertical={false} stroke="#F4F4F5" />
          <XAxis dataKey="day" tick={{ fontSize: 11, fill: '#71717A' }} tickFormatter={fmtDay} tickLine={false} axisLine={{ stroke: '#E7E7EA' }} interval={step - 1} />
          <YAxis tick={{ fontSize: 11, fill: '#71717A' }} tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip
            cursor={{ fill: '#F4F4F5' }}
            contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #E7E7EA', boxShadow: 'none' }}
            labelFormatter={(d: string) => fmtDay(d)}
            formatter={(v: number, name: string) => [`${v.toLocaleString('en-GB')}${unit ? ` ${unit}` : ''}`, name === 'uk' ? 'UK' : 'US']}
          />
          <Bar dataKey="uk" stackId="m" fill={UK} radius={[0, 0, 0, 0]} />
          <Bar dataKey="us" stackId="m" fill={US} radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      </div>
      <div className="flex gap-4 mt-2 text-[12px] text-stone-500">
        <span className="inline-flex items-center gap-1.5"><span className="w-2 h-2 rounded-sm" style={{ background: UK }} />UK</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-2 h-2 rounded-sm" style={{ background: US }} />US</span>
        <span className="ml-auto">London days</span>
      </div>
    </div>
  );
};
